export interface PeticionWeb
{
    id:number,
    tipo:number,
    nombre:string,
    telefono:string,
    //provincia:string,
    taller:string,
    marca:string,
    modelo:string,
    puertas:number,
    lamina:string,
    email:string,
    descr:string,
    observ:string,
    par1:string,
    usuario:string,
    empresa:string,
    hoja:number,
    matricula:string,
    siniestro:string,
    servicio:string
    created:string,
    //poblacion:string,
    estado_contact:string|number
    fecha_creacion:string,
    
}
/*
PEticion web new :
"damage_area": "Delantera",
es_te_llamamos
"tipo_vehiculo": "Coche",
"codigo_cita": "",
"fecha_cita": "",
		"other_damage_area": "",
        "damage_side": "",
        "cia": "ALLIANZ",
        /*
        "created": "2023-12-30T09:37:00",
		"modified": "2050-01-01T00:00:00",
        */
        /*"damage_type": "Menor que una moneda de 2€",
        "luna_afectada": "",
        "es_persona_riesgo": "No es Mayor de 60",
        "lead": "",
        "glass_treatment": "",
		"ai_confidence": ""
*/

export interface PeticionWebNew extends PeticionWeb
{
    area_dañada: string,
    thanks:string,
    tipo_vehiculo: string,
    codigo_cita: string,
    fecha_cita:string,
    other_damage_area:string,
    damage_side:string,
    cia:string,
    fecha_creacion:string,
    /*
        "created": "2023-12-30T09:37:00",
        "modified": "2050-01-01T00:00:00",
    */
    damage_type:string,
    luna_afectada:string,
    es_persona_riesgo:string,
    lead:string,
    glass_treatment:string,
    ai_confidence:string,
    estado:number,
}

export interface PeticionWebRauda extends PeticionWeb
{
    area_dañada: string,
    tipo_vehiculo: string,
    codigo_cita: string,
    fecha_cita:string,
    other_damage_area:string,
    damage_side:string,
    cia:string,
    fecha_creacion:string,
    /*
        "created": "2023-12-30T09:37:00",
        "modified": "2050-01-01T00:00:00",
    */
    damage_type:string,
    luna_afectada:string,
    lead:string,
    glass_treatment:string,
    ai_confidence:string,
    estado:number,
    creador:string,
    id_piloto: string,
}
export interface PeticionOutbound extends PeticionWeb
{
    nombre:string,
    telefono_contacto:string,
    origen:string,
    marca:string,
    modelo:string,
    luna_afectada:string,
    usuario:string,
    estado:number,
    cia:string,
    matricula:string,
    piloto:string,
    fecha_creacion:string
    fecha_modificacion:string,
    //created:string,
    //modified:string,
    id:number

}

export function traducirTipoGestion(tipo:number|string):string
{
    
    if(typeof tipo === "string")
    {
        try
        {
            tipo = parseInt(tipo);
        }
        catch(e)
        {
            return "???";
        }
    }
    switch (tipo)
    {
        case 0:
            return "Form.Contacto";
        case 1:
            return "Te Llamamos";
        case 2:
            return "Form.Servicios";
        case 3:
            return "Pide Cita";
        case 4:
            return "Chatbot";
        default:
            return tipo.toString();
    }    
}

export function traducirEstadoPeticionWeb(estado:number|string):string
{
    if(estado == undefined || estado == null)
    {
        return "Estado no definido";
    }
    if(typeof estado === "string")
    {
        estado = estado.toUpperCase();
    }
    switch (estado)
    {
        case 0:
        case "0":
        case"P":
            return "Pendiente";
        case 1:
        case "1":
        case"G":
            return "Gestionada";
        case 2:
        case "2":
        case"R":
            return "Rellamada";
        default:
            return estado.toString();
    }
}
//solo para la busqueda de peticiones con la opcion  de TODAS
// export function convertirPeticionWebNewAPeticionWeb(peticion:PeticionWebNew):PeticionWeb
// {
//     return {
//         id:peticion.id,
//         tipo:peticion.tipo,
//         nombre:peticion.nombre,
//         telefono:peticion.telefono,
//         //provincia:peticion.provincia,
//         taller:peticion.taller,
//         marca:peticion.marca,
//         modelo:peticion.modelo,
//         puertas:peticion.puertas,
//         lamina:peticion.lamina,
//         email:peticion.email,
//         descr:peticion.descr,
//         observ:peticion.observ,
//         par1:peticion.par1,
//         usuario:peticion.usuario,
//         empresa:peticion.empresa,
//         hoja:peticion.hoja,
//         matricula:peticion.matricula,
//         siniestro:peticion.siniestro,
//         servicio:peticion.servicio,
//          created: peticion.fecha_creacion && peticion.fecha_creacion !== "" 
//             ? peticion.fecha_creacion.toString()
//             : (peticion.created ? peticion.created.toString() : ""),
//         //poblacion:peticion.poblacion,
//         estado_contact:peticion.estado
//     };
// }
export function convertirPeticionWebAPeticionWebNew(peticion:PeticionWeb|any)
{
    return {
        id:peticion.id,
        tipo:peticion.tipo,
        nombre:peticion.nombre,
        telefono:peticion.telefono,
        //provincia:peticion.provincia,
        taller:peticion.taller,
        marca:peticion.marca,
        modelo:peticion.modelo,
        puertas:peticion.puertas,
        lamina:peticion.lamina,
        email:peticion.email,
        correo: peticion.correo || peticion.email || "", // <-- Añadido para exportación correcta
        descr:peticion.descr,
        observ:peticion.observ,
        par1:peticion.par1,
        usuario:peticion.usuario,
        empresa:peticion.empresa,
        hoja:peticion.hoja,
        matricula:peticion.matrícula,
        matrícula:peticion.matrícula,
        siniestro:peticion.siniestro,
        servicio:peticion.servicio,
        fecha_creacion: peticion.created || peticion.fecha_creacion || peticion.fecha_creación || "",
        area_dañada: peticion.área_dañada || "",
        thanks:peticion.thanks || "",
        tipo_vehiculo:peticion.tipo_vehículo||peticion.tipo_vehiculo || "",
        codigo_cita:peticion.código_cita ||peticion.codigo_cita || "",
        fecha_cita:peticion.fecha_hora_cita || peticion.fecha_cita || "",
        other_damage_area: peticion.other_damage_area || peticion.otra_área_dañada || peticion.otra_area_danada || "",
        damage_side:"",
        cia: peticion.cia||peticion.compania||peticion.aseguradora || "",
        damage_type:peticion.tipo_daño || peticion.tipo_dano || "",
        luna_afectada: peticion.luna_afectada || peticion.luna_afectada || peticion.tipo_crital || "",
        es_persona_riesgo:peticion.es_persona_riesgo || peticion.es_persona_riesgo || "",
        lead:peticion.lead || peticion.origen || "",
        glass_treatment:peticion.oper_cristal||"",
        ai_confidence:peticion.precisión_ia||peticion.precision_ia || "",
        estado_contact:peticion.estado || peticion.estado_contact || 0,
        estado: peticion.estado || 0,
        created: peticion.created || peticion.fecha_creacion || "",
    };
}
export function convertirPeticionWebAPeticionWebNewOld(peticion:PeticionWeb|any):PeticionWebNew
{
    return {
        id:peticion.id,
        tipo:peticion.tipo,
        nombre:peticion.nombre,
        telefono:peticion.telefono,
        //provincia:peticion.provincia,
        taller:peticion.taller,
        marca:peticion.marca,
        modelo:peticion.modelo,
        puertas:peticion.puertas,
        lamina:peticion.lamina,
        email:peticion.email,
        descr:peticion.descr,
        observ:peticion.observ,
        par1:peticion.par1,
        usuario:peticion.usuario,
        empresa:peticion.empresa,
        hoja:peticion.hoja,
        matricula:peticion.matrícula,
        siniestro:peticion.siniestro,
        servicio:peticion.servicio,
        fecha_creacion: peticion.created || peticion.fecha_creacion || peticion.fecha_creación || "",
        area_dañada: peticion.área_dañada || "",
        thanks:peticion.thanks || "",
        tipo_vehiculo:peticion.tipo_vehículo||peticion.tipo_vehiculo || "",
        codigo_cita:peticion.código_cita ||peticion.codigo_cita || "",
        fecha_cita:peticion.fecha_hora_cita || peticion.fecha_cita || "",
        other_damage_area: peticion.other_damage_area || peticion.otra_área_dañada || peticion.otra_area_danada || "",
        damage_side:"",
        cia: peticion.cia||peticion.compania||peticion.aseguradora || "",
        damage_type:peticion.tipo_daño || peticion.tipo_dano || "",
        luna_afectada: peticion.luna_afectada || peticion.luna_afectada || peticion.tipo_crital || "",
        es_persona_riesgo:peticion.es_persona_riesgo || peticion.es_persona_riesgo || "",
        lead:peticion.lead || peticion.origen || "",
        glass_treatment:peticion.oper_cristal||"",
        ai_confidence:peticion.precisión_ia||peticion.precision_ia || "",
        estado_contact:peticion.estado || peticion.estado_contact || 0,
        estado: peticion.estado || 0,
        created: peticion.created || peticion.fecha_creacion || "",
    };
}